import Vue from 'vue';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(errors);
};

export default report => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('news/send-error-report', report)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/news/sendReport.js